import { defineComponent, h } from 'vue';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { t } from '@/ui/i18n/i18n';

export const UnknownItem = defineComponent<ItemProps>({
  name: 'UnknownItem',
  props: ['item'],
  setup(props) {
    return function render() {
      return h('div', [t('inspection-report.unknown', { type: props.item.type })]);
    };
  },
});
